package pl.decks.personal.components.graphics.heropatterns

import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import pl.decks.personal.extensions.svgBackground

fun Modifier.heroPatternBackground(
    pattern: HeroPattern,
    color: Color,
    scale: Double = 1.0,
    repeatX: Boolean = true,
    repeatY: Boolean = true,
    position: CSSPosition = CSSPosition.Bottom,
): Modifier = this.svgBackground(
    dataUrl = pattern.toDataUrl(color),
    scale = pattern.baseWidth * scale to pattern.baseHeight * scale,
    repeatX = repeatX,
    repeatY = repeatY,
    position = position,
)
